
import { motion } from "framer-motion";
import { Heart } from "lucide-react";

export const ParentsBenefits = () => {
  return (
    <motion.div 
      className="mt-16 mb-8 bg-white/90 backdrop-blur-sm max-w-3xl mx-auto rounded-xl p-8 shadow-xl"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.8 }}
    >
      <h3 className="text-2xl font-bold mb-4 text-primary">Why Parents Love MiniMakes</h3>
      <div className="grid md:grid-cols-2 gap-6 text-left">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <Heart className="w-6 h-6 text-primary" />
          </div>
          <div>
            <h4 className="font-semibold mb-1">Safe & Educational</h4>
            <p className="text-gray-600 text-sm">Every recipe includes age-appropriate safety tips and fascinating science facts</p>
          </div>
        </div>
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <Heart className="w-6 h-6 text-primary" />
          </div>
          <div>
            <h4 className="font-semibold mb-1">Build Confidence</h4>
            <p className="text-gray-600 text-sm">Kids learn essential life skills while having fun in the kitchen</p>
          </div>
        </div>
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <Heart className="w-6 h-6 text-primary" />
          </div>
          <div>
            <h4 className="font-semibold mb-1">Quality Time</h4>
            <p className="text-gray-600 text-sm">Create precious memories while teaching valuable cooking skills</p>
          </div>
        </div>
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <Heart className="w-6 h-6 text-primary" />
          </div>
          <div>
            <h4 className="font-semibold mb-1">Healthy Habits</h4>
            <p className="text-gray-600 text-sm">Learn about nutrition and develop healthy eating habits early</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};
